import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { actions } from '../../store/index';
import { withStyles } from '@material-ui/core/styles';
import { Button, FormControl, Grid, Input, InputLabel, Paper, Select, TextField, Typography } from '@material-ui/core';
import classnames from 'classnames';
import SimpleTable from 'components/SimpleTable';
import ExpandableCell from 'components/SimpleTable/ExpandableCell';
import svc from 'svc';
import { memoize } from "lodash";



const styles = theme => ({
	gridRoot: {
		flexGrow: 1,
		width: '100%',
		margin: 16,
	},
	searchButton: {
		marginRight: 16,
	},
	searchTable: {
		minHeight: 600,
		marginTop: 30,
		marginRight: 32,
	},
	formField: {
		width: '100%',
	},
});

const searchCols = [
	{ name: 'CardCode', title: 'BP Code' },
	{ name: 'CardName', title: 'BP Name' },
	{ name: 'Phone', title: 'Phone' },
	{ name: 'SalesEmployee', title: 'Sales Employee' },
	{ name: 'SStreet', title: 'Ship-to Street' },
	{ name: 'SCity', title: 'Ship-to City' },
	{ name: 'SState', title: 'Ship-to State' },
	{ name: 'ContactPerson', title: 'Default Contact' },
	{ name: 'DealerGroup', title: 'Dealer Group' },
	{ name: 'Remarks', title: 'Remarks' },
	{ name: 'BPPriority', title: 'BP Priority' },
];



class BPSearch extends React.PureComponent {
	state = {
		values: {
			CardCode: '',
			CardName: '',
			Phone: '',
			SCity: '',
			BPPriority: '',
			DefaultContact: '',
			SlpCode: '',
		},
		searching: false,
		rows: [],
		redirect: '',
	};


	componentDidMount = () => {
		if ( this.props.appData.UserSlpCode ) {
			let slp = Number(this.props.appData.UserSlpCode);
			if ( slp !== -1 ) this.setState({ values: { ...this.state.values, SlpCode: slp } });
		}
	};


	updateSearchVal = memoize(key => event => {
		this.setState({
			values: {
				...this.state.values,
				[ key ]: event.target.value,
			},
		});
	});

	handleSearch = ( e ) => {
		e.preventDefault();
		this.setState({ searching: true, rows: [] });

		svc.send('bp', { method: 'search', ...this.state.values }).then(res => {
			this.setState({
				searching: false,
				rows: res.payload.data,
			});
		});
	};


	onRowSelect = ( sel ) => {
		if ( !sel.length ) {
			return false;
		}

		let row = this.state.rows[ sel[ 0 ] ];

		window.open(`/businesspartners/view/${row.CardCode}`);
	};


	newBP = () => {
		this.setState({ redirect: '/businesspartners/new' });
	};




	render() {
		const classes = this.props.classes;
		const tableClass = classnames(classes.searchTable, this.state.searching && 'automat-loading');
		let values = this.state.values;

		return (
			<div>
				<form onSubmit={this.handleSearch} className={classes.formField}>
					<Grid container className={classes.gridRoot} spacing={16}>

						<Grid item xs={12}>
							<Typography variant="h6">Business Partner Search</Typography>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.CardCode}
								label="BP Code"
								onChange={this.updateSearchVal('CardCode')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.CardName}
								label="BP Name"
								onChange={this.updateSearchVal('CardName')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.Phone}
								label="Phone"
								onChange={this.updateSearchVal('Phone')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<FormControl className={classes.formField}>
								<InputLabel shrink>Sales Employee</InputLabel>
								<Select
									native
									input={<Input />}
									onChange={this.updateSearchVal('SlpCode')}
									value={values.SlpCode}
									className={classes.formField}
								>
									<option value="" />
									{
										this.props.appData.SalesPersons.map(( opt, index ) => {
											return <option key={index} value={opt.val}>{opt.disp}</option>
										})
									}
								</Select>
							</FormControl>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.SCity}
								label="Shipping City"
								onChange={this.updateSearchVal('SCity')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.DefaultContact}
								label="Default Contact"
								onChange={this.updateSearchVal('DefaultContact')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<FormControl className={classes.formField}>
								<InputLabel shrink>BP Priority</InputLabel>
								<Select
									native
									input={<Input />}
									onChange={this.updateSearchVal('BPPriority')}
									value={values.BPPriority}
									className={classes.formField}
								>
									<option value="" />
									{
										this.props.appData.BPPriorities.map(( opt, index ) => {
											return <option key={index} value={opt.val}>{opt.disp}</option>
										})
									}
								</Select>
							</FormControl>
						</Grid>

						<Grid item xs={6} md={4} lg={3} xl={3}>
							<Button
								variant="contained"
								color="primary"
								className={classes.searchButton}
								onClick={this.handleSearch}
								disabled={this.state.searching}
								type={'submit'}
							>
								Search
							</Button>

							<Button
								variant="contained"
								color="primary"
								className={classes.searchButton}
								onClick={this.newBP}
							>
								Create New
							</Button>
						</Grid>

						<Grid item xs={12}>
							<Paper className={tableClass}>
								<SimpleTable
									columns={searchCols}
									rows={this.state.rows}
									onRowSelect={this.onRowSelect}
									defaultPageSize={15}
									cellComponent={ExpandableCell}
								/>
							</Paper>
						</Grid>

					</Grid>

					{
						this.state.redirect
						&& window.location.pathname !== this.state.redirect
						&& <Redirect to={this.state.redirect} push />
					}

				</form>
			</div>
		);
	}
}



const mapStateToProps = state => {
	return {
		appData: state.appData,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		setTitle: ( title ) => {
			dispatch(actions.layout.setTitle(title));
		},
	}
};

BPSearch = withStyles(styles)(BPSearch);
export default connect(mapStateToProps, mapDispatchToProps)(BPSearch);